/* eslint-disable require-jsdoc */
export class Lead {
    constructor() {
        this.content = "";
    }
}
